module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_link_image_item-b244e547c7e064fab4e26d366bcc6bd3.jpg";